const ArticleMiniCardLoading = () => {
  return (
    <div className="mr-3 mb-5 w-56 shrink-0">
      <div className="h-[182px] w-full animate-pulse bg-N200 dark:bg-DN200" />
      <p className="mt-2.5 h-12 text-readingTextLarge font-bold leading-readingTextLarge text-N900 line-clamp-2 dark:text-DN900">
        <div className="h-full w-[90%] animate-pulse bg-N200 dark:bg-DN200" />
      </p>
    </div>
  );
};

export default ArticleMiniCardLoading;
